



import { Component, Prop } from 'vue-property-decorator';
import SaascadaVue from '@/components/Shared/SaascadaVue';
import FeeState from "@/models/Accounts/Shared/Fees/FeeState";

@Component({ name: 'FeeState', })
export default class extends SaascadaVue {

    @Prop({ required: true })
    state: FeeState;

    get textColor() {
        var color: string = "grey--text";
        switch (this.state) {
            case FeeState.Paid:
                color = "success--text";
                break;
            case FeeState.Created:
            case FeeState.Pending:
                color = "warning--text";
                break;
            case FeeState.Failed:
                color = "error--text";
                break;
        }
        return color;
    }

}
